export { default as Typography } from "@mui/material/Typography";
